import { getStyle } from './getStyle';
export var setStyleProperty = function (attr, value, el) {
    // any type because of https://github.com/Microsoft/TypeScript/issues/17827
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getStyle(el)[attr] = value;
};
